import React from "react";
import StyledLoading from "../StyledLoading";

const Loading = () => {
	return (
		<StyledLoading>
			<div className="center">
				<div className="smartphone">
					<div className="content">
						<ul>
							<li></li>
							<li></li>
							<li></li>
							<li style={{ width: "90%" }}></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li style={{ width: "60%" }}></li>
							<li></li>
							<li></li>
							<li style={{ width: "70%" }}></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
						</ul>
					</div>
				</div>

				<div className="tablet">
					<div className="content">
						<div className="wrap">
							<ul>
								<li></li>
								<li></li>
								<li></li>
								<li style={{ width: "90%" }}></li>
								<li></li>
								<li></li>
								<li></li>
								<li></li>
								<li style={{ width: "60%" }}></li>
								<li></li>
								<li></li>
								<li style={{ width: "70%" }}></li>
								<li style={{ width: "50%" }}></li>
							</ul>
							<ul>
								<li></li>
								<li></li>
								<li></li>
								<li style={{ width: "90%" }}></li>
								<li></li>
								<li></li>
								<li></li>
								<li></li>
								<li style={{ width: "60%" }}></li>
								<li></li>
								<li></li>
								<li style={{ width: "70%" }}></li>
								<li style={{ width: "80%" }}></li>
							</ul>
						</div>
					</div>
				</div>

				<div className="laptop">
					<div className="content">
						<ul>
							<li></li>
							<li></li>
							<li></li>
							<li style={{ width: "90%" }}></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li style={{ width: "60%" }}></li>
							<li></li>
							<li></li>
							<li style={{ width: "70%" }}></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li></li>
							<li style={{ width: "50%" }}></li>
						</ul>
					</div>
				</div>
			</div>
		</StyledLoading>
	);
};

export default Loading;
